export enum apiPrefix {
  DATSET_SERVICE_PREFIX = "dataset/idp/api",
  ADMIN_MODEL_SERVICE_PREFIX = "admin-model/idp/api",
  ADMIN_SERVICE_PREFIX = "ad/idp/api",
  ADMIN_DATASET_SERVICE_PREFIX = "admin-dataset/idp/api",
  USER_SERVICE_PREFIX = "user/idp/api",
  MODEL_SERVICE_PREFIX = "model/idp/api",
  USECASE_SERVICE_PREFIX = "usecase/idp/api",
  IDP_ADMIN_PREFIX = "idp/api",
  SELFCARE_DATASET_UPLOAD_PREFIX = "du/idp/api",
  NOTIFICATION_SERVICE_PREFIX = "noti/idp/api",
  AUDIT_SERVICE = "audit-trail/idp/api",
  ADMIN_SEARCH_SERVICE_PREFIX = "admin-search/idp/api",
  ADMIN_TOOLKIT_SERVICE_PREFIX = "admin-toolkit/idp/api",
  ADMIN_CONTENT_SERVICE_PREFIX = "admin-content/idp/api",
  ADMIN_USER_SERVICE_PREFIX = "admin-user/idp/api",
  ADMIN_USECASE_SERVICE_PREFIX = "admin-usecase/idp/api",
  ADMIN_OSTICKET_SERVICE_PREFIX = "admin-osticket/api",
  ADMIN_CONFIG_SERVICE_PREFIX = "admin-config/api",
  ADMIN_ARTIFACT_SERVICE_PREFIX = "admin-artifact/idp/api",
  ADMIN_COMPUTE_PREFIX = "admin-compute/idp/api",
  COMPETITION_SERVICE_PREFIX = "competition/idp/api",
}
